<template>
  <div id="members" class="px-4 mt-4">
    <div class="row">
      <div class="col-12 d-flex justify-content-between">
        <h2 class="view-title">Exportar cotizaciones</h2>
        <div class="d-flex justify-content-end">
          <router-link
            tag="button"
            class="btn btn-outlined mr-2 d-flex align-items-center"
            :to="{ name: 'adminDashboard' }"
          >
            <span class="icon-cot-undo mr-2"></span>
            Regresar a dashboard
          </router-link>
        </div>
      </div>
      <div class="col-6 mt-2">
        <p class="content-text">
          Descarga un reporte de todas tus clientes en formato xls. Esto te
          permitirá abrirlo en tu hoja de cálculo preferida y crear reportes
          internos de ventas de forma rápida y eficiente.
        </p>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-6">
        <div class="cotizarlo-general-wrapper wrapper-padding">
          <h3 class="subtitle-section">Descarga tus cotizaciones</h3>
          <div class="row mt-3">
            <div class="col d-flex align-items-center">
              <div class="form-group mb-0">
                <div class="input-group flex-nowrap d-flex">
                  <div class="input-group-prepend flex-fill">
                    <div class="input-group-text w-100">Fecha</div>
                  </div>
                  <div class="input-append-select flex-fill">
                    <button
                      class="cotizarlo-select dropdown-toggle my-0"
                      type="button"
                      id="menuExport"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style="border: none"
                    >
                      <span>{{ period.value }}</span>
                      <img
                        class="dropdown-icon mx-2"
                        src="@/assets/icons/abajo_blue.svg"
                        width="15px"
                      />
                    </button>
                    <div
                      class="dropdown-menu dropdown-select-menu dropdown-menu-right"
                      aria-labelledby="menuExport"
                    >
                      <div
                        class="dropdown-item d-flex py-1"
                        @click="selectPeriod('15days', 'Últimos 15 días')"
                      >
                        <span>15 días</span>
                      </div>
                      <div
                        class="dropdown-item d-flex py-1"
                        @click="selectPeriod('30days', 'Últimos 30 días')"
                      >
                        <span>30 días</span>
                      </div>
                      <div
                        class="dropdown-item d-flex py-1"
                        @click="selectPeriod('90days', 'Últimos 90 días')"
                      >
                        <span>90 días</span>
                      </div>
                      <div
                        class="dropdown-item d-flex py-1"
                        @click="selectPeriod('year', 'Ùltimo año')"
                      >
                        <span>Ùltimo año</span>
                      </div>
                      <div
                        class="dropdown-item d-flex py-1"
                        @click="selectPeriod('All', 'Todas')"
                      >
                        <span>Todas</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col">
              <button class="btn btn-simple" @click="getPeriodData()">
                Descargar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import adminSettingsService from "@/api/Admin/settings";
export default {
  data() {
    return {
      period: {
        period:'15days',
        value: " Ùltimos 15 días"
      }
    }
  },
  methods:{
    selectPeriod(period, value){
      this.period.period = period
      this.period.value = value
    },
    getPeriodData(){
      let data = new FormData()
      data.append("period", this.period.period)
      adminSettingsService.exportClients(data).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.className="pdf-download"
        link.href = url;
        link.setAttribute('download', 'clientes.csv'); //or any other extension
        document.body.appendChild(link);
        link.click();

      })
      .catch(() => {
        this.$store.dispatch('showLoader',{show:false});
      });
    },
  }
};
</script>